import React from "react";
import MessageLog from "./message.log";
import MessageInput from "./message.input";
import Suggestions from "./suggestions";
import ReplyOptions from "./reply.options";
import Rating from "./rating";
import {ChatHeader} from "./chat.header";
import {LiveChatToggler} from "./live.chat.toggler";
import {useAdminSidebarDrag} from "./use.admin.sidebar.drag";
import {SearchResultsPanel, SearchResultsDropdown} from "./search.results.panel";
import {useIsNarrow} from "./use.narrow";

export const Chat = ({ onClose, inlineMode, sidebarMode, isAdmin }) => {
    const { containerRef, positionStyle, onHeaderMouseDown } = useAdminSidebarDrag(isAdmin, sidebarMode);
    const isNarrow = useIsNarrow();
    return (
        <div
            ref={containerRef}
            style={positionStyle}
            className={`sb-chat-container -v1 ${isAdmin ? 'sb-chat-container--admin' : ''} ${inlineMode ? 'sb-chat-container--inline' : ''} ${sidebarMode ? 'sb-chat-container--sidebar' : 'sb-chat-container--page'}`}
        >
            <div className="sb-chat-container__content">
                <ChatHeader onClose={onClose} inlineMode={inlineMode} sidebarMode={sidebarMode} onDragStart={isAdmin && sidebarMode ? onHeaderMouseDown : null}/>

                {/* Offered to every company admin, no longer only on trial or after a
                    negative rating; LiveChatToggler hides itself where live help is
                    not reachable. */}
                <LiveChatToggler />

                {sidebarMode ? (
                    <MessageLog/>
                ) : (
                    <div className="sb-chat--page-layout">
                        <MessageLog/>
                        <SearchResultsPanel/>
                    </div>
                )}
                {(sidebarMode || isNarrow) && <SearchResultsDropdown/>}
                <Suggestions/>
                <ReplyOptions/>
                <Rating/>
                <MessageInput/>
            </div>
        </div>
    );
};
